<template>
  <div>
    <v-menu
      v-if="!readonly && !disabled"
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="localData | format"
          :label="name"
          prepend-inner-icon="mdi-clock-time-four-outline"
          readonly
          outlined
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        ref="picker"
        v-model="localData"
        format="24hr"
        @change="save"
      ></v-time-picker>
    </v-menu>

    <v-text-field
      v-else
      :value="localData | format"
      :label="name"
      prepend-inner-icon="mdi-clock-time-four-outline"
      :readonly="readonly"
      :disabled="disabled"
      outlined
    ></v-text-field>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import moment from 'moment';

export default {
  name: 'Input',

  filters: {
    format(value) {
      if (!value) return '';

      return value;
    }
  },

  model: {
    prop: 'data'
  },

  props: {
    data: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    menu: false,
    localData: null
  }),

  computed: {},

  watch: {
    localData: {
      deep: true,
      handler: 'setTranslation'
    },
    data: {
      deep: true,
      handler() {
        if (JSON.stringify(this.data) === JSON.stringify(this.localData)) {
          return;
        }
        this.setData();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'DATE'));
    }
  },

  created() {},

  methods: {
    setData() {
      this.localData = cloneDeep(this.data);
    },
    setTranslation() {
      this.$emit('input', this.localData);
    },
    save(date) {
      this.$refs.menu.save(date);
      this.localData = date;
    }
  }
};
</script>
